import { styled } from '@mui/material/styles';

export const TwoWayMatchTableDragSourceRoot = styled('div')(() => ({}));

export const TwoWayMatchTableArea = styled('div')(() => ({
  position: 'absolute',
  pointerEvents: 'none',
}));
